export const talPdfConfig = {
  header: 'Talent Attraction Lab',
  subHeading: 'Uncover the drivers that attract cadidates to a role',
  summaryHeading: 'Data snapshot',
};
